import { render } from "./FoodPointCreate.vue?vue&type=template&id=24a2fad2"
import script from "./FoodPointCreate.vue?vue&type=script&lang=js"
export * from "./FoodPointCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/undanet/pej22-webadmin/front-end/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__